import { BarChart } from './barChart/BarChart';
import { getBarChartProps } from './barChart/helpers/getBarChartProps';
import { WebAPIChartSlicerData } from '../../globals/webApiTypes/elements/WebAPICBS';
import { parseDataset } from './helpers/parseDataset';
import { LineGraph } from './lineGraph/LineGraph';
import { getLineGraphProps } from './lineGraph/helpers/getLineGraphProps';

export const GraphView = ({
	chartSlicerData,
	dataEntryList,
}: {
	chartSlicerData: WebAPIChartSlicerData;
	dataEntryList: ReturnType<typeof parseDataset>;
}) => {
	const { graphType } = chartSlicerData;

	switch (graphType) {
		case 'Staafdiagram': {
			const barChartProps = getBarChartProps({
				...chartSlicerData,
				dataEntryList,
			});

			return <BarChart {...chartSlicerData} {...barChartProps} />;
		}
		default: // in case no graphType is given, treat it like a line-graph
		case 'Lijngrafiek': {
			const lineGraphProps = getLineGraphProps({
				...chartSlicerData,
				dataEntryList,
			});
			return <LineGraph {...chartSlicerData} {...lineGraphProps} />;
		}
	}
};
